<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'Releases/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'ReleasesIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'Releases' */ './ModalNew')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
